<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<div *ngIf="isMobile">
  <h4 class="mobile-nav-title mb-2" i18n>Calendar</h4>
</div>

<div class="container-fluid">
  <div *ngIf="!isMobile">
    <app-header titleText="CALENDAR" i18n-titleText></app-header>
  </div>

  <form class="row mb-3" (ngSubmit)="dateOrViewChanged()">
    <div class="col-sm-3">
      <mat-select class="form-control"
                  [(value)]="filter.crew">
        <mat-select-trigger>
          <div *ngIf="filter.crew; else noCrew">
            <div class="color-swatch"
                 [style.background-color]="filter.crew.crew_Color">&nbsp;</div>
            {{filter.crew.crew_Name}}
          </div>
          <ng-template #noCrew i18n>Select Crew</ng-template>
        </mat-select-trigger>
        <mat-option value="" i18n>Select Crew</mat-option>
        <mat-option *ngFor="let crew of crews" [value]="crew">
          <div class="color-swatch" [style.background-color]="crew.crew_Color">&nbsp;</div>
          {{crew.crew_Name}}
        </mat-option>
      </mat-select>
    </div>    
    <div class="col-sm-3">
      <select name="quoteId" id="quoteID"
              class="form-control select-bidit"
              [(ngModel)]="filter.quoteId" #quoteId="ngModel">
        <option selected="selected" [value]="null" i18n>Select Project</option>
        <option *ngFor="let project of this.projects" [ngValue]="project.quoteId">{{project.quoteName}}</option>
      </select>
    </div>
    <div class="col-sm-3">
      <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
      <button *ngIf="canEdit" type="button" class="btn btn-bidit-action ml-1" (click)="addAppointment()" i18n>Add Appointment</button>
    </div>
  </form>

  <div class="row mb-3 align-middle">
    <div class="col-md-6">
      <h3>
        {{
 viewDate | calendarSchedulerDate: view + 'ViewTitle'
            :locale:weekStartsOn:excludeDays:viewDays
        }}
      </h3>
    </div>

    <div class="col-md-3">
      <div class="form-inline">
        <div class="mr-2 material-icons" (click)="printWorkOrders()">
          print
        </div>
        <select [(ngModel)]="filter.viewMode" class="col form-control select-bidit" (change)="changeView()">
          <option value="Month" i18n>Month View</option>
          <option value="Week" selected="selected" i18n>Week View</option>
          <option value="Day" i18n>Day View</option>
        </select>
      </div>
    </div>
    <div class="col-md-3">
      <button type="button" class="btn btn-bidit-action mr-1"
              (click)="previousView()" i18n>Previous</button>
      <button type="button" class="btn btn-bidit-navigate mr-1"
              mwlCalendarToday
              [(viewDate)]="viewDate"
              (viewDateChange)="dateOrViewChanged()" i18n>Current</button>
      <button type="button" class="btn btn-bidit-action"
              (click)="nextView()" i18n>Next</button>
    </div>
  </div>

  <ng-template #customCellTemplate let-day="day" let-locale="locale"
               let-tooltipPlacement="tooltipPlacement"
               let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay"
               let-eventClicked="eventClicked"
               let-eventTimesChanged="eventTimesChanged"
               let-tooltipTemplate="tooltipTemplate"
               let-tooltipAppendToBody="tooltipAppendToBody" let-tooltipDelay="tooltipDelay"
               let-validateDrag="validateDrag">
    <div class="cal-cell-top">
      <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{ day.badgeTotal }}</span>
      <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
    <div *ngFor="let event of day.events" class="cal-events"
         [ngStyle]="{ 'backgroundColor': event.color?.secondary, 'border-color': event.color?.primary, 'margin': isMobile ? '3px 0' : '' }"
         [ngClass]="event?.cssClass" (mwlClick)="eventClicked.emit({event: event})" [mwlCalendarTooltip]="event.title | calendarEventTitle: 'monthTooltip':event"
         [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event" [tooltipTemplate]="tooltipTemplate"
         [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay"
         mwlDraggable
         [class.cal-draggable]="event.draggable"
         dragActiveClass="cal-drag-active"
         [dropData]="{ event: event, draggedFrom: day }"
         [dragAxis]="{ x: event.draggable, y: event.draggable }"
         [validateDrag]="validateDrag">
      <span *ngIf="event.start > day.date">{{event.start | date: 'h:mm a'}} - </span>
      <span *ngIf="event.start < day.date">12:00 AM - </span>
      {{event.title}}
      <span *ngIf="(event.end | date:'M/d/yyyy') == (day.date | date: 'M/d/yyyy')"> - {{event.end | date: 'h:mm a'}}</span>
      <span *ngIf="(event.end | date:'M/d/yyyy') != (day.date | date: 'M/d/yyyy')"> - 11:59 PM</span>
    </div>
  </ng-template>
  <ng-template #eventTitleTemplate>
    <span>{{event.title}} - {{event.content}}</span>
  </ng-template>

  <ng-template #currentTimeMarkerTemplate
               let-topPx="topPx">
    <div class="cal-current-time-marker"
         *ngIf="isTimeOfDayVisible"
         [style.top.px]="topPx"></div>
  </ng-template>

  <app-spinner [isRunning]="isRequesting"></app-spinner>
  <div mat-icon-button class="close-button" [mat-dialog-close]="true">

    <div *ngIf="!isRequesting" [ngSwitch]="view">
      <mwl-calendar-month-view *ngSwitchCase="'month'"
                               [viewDate]="viewDate"
                               [events]="events"
                               [locale]="locale"
                               [activeDayIsOpen]="false"
                               [cellTemplate]="customCellTemplate"
                               (eventClicked)="eventClicked('click', $event)"
                               (eventTimesChanged)="eventTimesChanged($event)">
      </mwl-calendar-month-view>
      <mwl-calendar-week-view *ngSwitchCase="'week'"
                              [viewDate]="viewDate"
                              [currentTimeMarkerTemplate]="currentTimeMarkerTemplate"
                              [events]="events"
                              [locale]="locale"
                              [viewDays]="viewDays"
                              [weekStartsOn]="weekStartsOn"
                              [hourSegments]="hourSegments"
                              [dayStartHour]="dayStartHour"
                              [dayEndHour]="dayEndHour"
                              (eventClicked)="eventClicked('click', $event)"
                              (eventTimesChanged)="eventTimesChanged($event)" Code File Line Column
                              [refresh]="refresh">
      </mwl-calendar-week-view>
      <mwl-calendar-day-view *ngSwitchCase="'day'"
                             [viewDate]="viewDate"
                             [currentTimeMarkerTemplate]="currentTimeMarkerTemplate"
                             [events]="events"
                             [locale]="locale"
                             [viewDays]="1"
                             [weekStartsOn]="weekStartsOn"
                             [hourSegments]="hourSegments"
                             [dayStartHour]="dayStartHour"
                             [dayEndHour]="dayEndHour"
                             (eventClicked)="eventClicked('click', $event)"
                             [refresh]="refresh"
                             (eventTimesChanged)="eventTimesChanged($event)">
      </mwl-calendar-day-view>
    </div>
  </div>
